import Card from "./card/Index";

const Membresias = ({ data, params, onClick, onChange }) => {
  return (
    <div className="min-vh-100 bg-light py-3 py-md-4">
      <div className="container-fluid px-2 px-md-3">
        <div className="row mb-3 mb-md-4 g-3">
          <div className="col-12 col-lg-6">
            <h2 className="fw-bold mb-0">Membresías</h2>
            <p className="text-muted small mb-0">
              Gestión de membresías y usuarios activos
            </p>
          </div>

          <div className="col-12 col-lg-6 d-flex flex-column flex-sm-row justify-content-lg-end align-items-stretch align-items-sm-center gap-2">
            <button
              className="btn btn-primary rounded-pill px-3 px-md-4"
              name="modal"
              onClick={(event) => onClick(event)}
            >
              <i className="bi bi-plus-circle"></i>
              <span className="d-none d-sm-inline ms-1">Añadir Membresía</span>
              <span className="d-inline d-sm-none ms-1">Añadir</span>
            </button>

            <button
              className="btn btn-outline-primary rounded-pill px-3 px-md-4"
              name="membresia_users"
              onClick={(event) => onClick(event)}
            >
              <i className="bi bi-person-plus"></i>
              <span className="d-none d-sm-inline ms-1">Añadir Usuarios</span>
              <span className="d-inline d-sm-none ms-1">Usuarios</span>
            </button>
          </div>
        </div>

        <div className="row mb-3 mb-md-4">
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <label className="text-muted mb-2 small fw-bold">Filtrar por estado</label>
            <select
              className="form-select"
              aria-label="Filtrar por estado"
              name="filtro-status"
              onChange={(event) => onChange(event)}
            >
              {params.status == 1 ? (
                <option selected>Activos</option>
              ) : (
                <option value="1">Activos</option>
              )}
              {params.status == 2 ? (
                <option selected>Inactivos</option>
              ) : (
                <option value="2">Inactivos</option>
              )}
            </select>
          </div>
        </div>

        <div className="row">
          {data
            ? data.data.memberships.map((m, index) => (
                <Card
                  key={m.id || index}
                  index={index}
                  data={m}
                  grafic={data.data.grafic.length === 0 ? [] : data.data.grafic[m.code]}
                  onClick={onClick}
                />
              ))
            : ""}
        </div>
      </div>
    </div>
  );
};

export default Membresias;
